import type { OmitStrict } from '@nx/stdlib';

import type { Nullable } from '../../types/utility';

export interface FullFilterRule {
  id: string;
  applied: boolean;
  applyType: boolean;
  type: string;
  entryId: number | string;
  basedOn: string;
  boolValues: ('true' | 'false')[];
  condition: Nullable<string>;
  conditionValue: Nullable<string | number>;
  conditionValueRange: Nullable<string | number>;
  stringValues: string[];
  isTimeZoneConvertEnabled: boolean;
  selectedTimeZone: string;
}

export type InitialFilterRule = Pick<FullFilterRule, 'id' | 'applied' | 'applyType'>;

export const isFullFilterRule = (rule: FilterRule): rule is FullFilterRule => {
  return 'entryId' in rule && 'type' in rule;
};

export type FilterRule = InitialFilterRule | FullFilterRule;

export type RulePayload = OmitStrict<FilterRule, 'id'>;

export interface FilterState {
  filterRules: FilterRule[];
}

export type GetRuleByFilterRuleId = (id: string) => FilterRule | undefined;
